import USBButton from '@usb-shield/react-button/dist/esm'
import USBIconRemove from '@usb-shield/react-icons/dist/esm/icon-remove'
import { BlockLayout } from '@usb-ui-tools/react-billpay-layout'
import { PropTypes } from 'prop-types'
import { useEffect } from 'react'
import { appCache } from '../../../../../context/appCache'
import { useMultilingualService } from '../../../../../service/multilingualService'
import { isOLBOrIpadApp } from '../../../../../utils/browserutils'
import getUSBExBillerLogo from '../../../../../utils/extBillerLogo'
import PreAuthTokensInput from '../preAuthInput'
import '../verifyBills.scss'

const VerifyBillsContainer = ({
  verifiedBills,
  nonVerifiedBills,
  handleOnChange,
  errors,
  // updateCallback,
  errorCount,
  count,
  handleBillerRemoval,
  inlineMsg,
  apierror
}) => {
  const { READY_TO_GO } = useMultilingualService('findbills')
  useEffect(() => {
    document.title = 'Verify bills'
    appCache({ ...appCache(), Title: 'Verify bills' })
  }, [])

  return (
    <div className="verify-bill">
      {nonVerifiedBills.length > 0 &&
        nonVerifiedBills.map(
          (
            { payeeId, merchantData, payeeAccountInfo, verificationTokens },
            i
          ) => (
            <BlockLayout
              actAs="CardChild"
              gapOnBottom={
                isOLBOrIpadApp() && i === nonVerifiedBills?.length - 1
                  ? '0'
                  : '8'
              }
              key={payeeId}
            >
              <div className="verify-bill-biller-details">
                <img
                  name="logo"
                  src={getUSBExBillerLogo(merchantData?.billerLogoUrl)}
                  alt="biller logo"
                  aria-hidden
                  style={{ height: '2.5rem', width: '2.5rem' }}
                />
                <div
                  id={`biller_${i}`}
                  className="verify-bill-billname usb-tg-body-medium"
                >
                  {merchantData?.billerName}
                  <p className="usb-tg-caption usb-c-gray-70">
                    {payeeAccountInfo &&
                      payeeAccountInfo[0]?.maskedaccountNumber}
                  </p>
                </div>
                <div className="verify-bill-remove-btn">
                  {nonVerifiedBills.length > 1 && (
                    <USBButton
                      variant="text"
                      id="verify-remove-btn"
                      type="button"
                      ariaLabel="remove bill"
                      size="small"
                      spacing={{ margin: 0, padding: 0 }}
                      handleClick={() => {
                        handleBillerRemoval(payeeId)
                      }}
                    >
                      <USBIconRemove
                        addClasses="remove-icon"
                        colorVariant="interaction"
                        size={18.5}
                      />
                    </USBButton>
                  )}
                </div>
              </div>
              <section
                style={{ width: isOLBOrIpadApp() ? '75%' : '100%' }}
                className="labeltext"
              >
                {count < 4 && (
                  <PreAuthTokensInput
                    preAuthTokens={verificationTokens}
                    handleOnChange={handleOnChange}
                    errors={errors}
                    payeeId={payeeId}
                    // updateCallback={(inputObj) =>
                    //   updateCallback(inputObj)
                    // }
                    errorCount={errorCount}
                    inlineMsg={inlineMsg}
                    apierror={apierror}
                  />
                )}
              </section>
            </BlockLayout>
          )
        )}

      {verifiedBills.length > 0 && (
        <>
          {verifiedBills.map(
            ({ payeeId, merchantData, payeeAccountInfo }, i) => (
              <BlockLayout
                actAs="CardChild"
                contentOnTop={
                  i === 0 && (
                    <p
                      id={`${READY_TO_GO?.ALREADY_ADDED}_subheader`}
                      className={`usb-tg-subheader-small usb-c-gray-80 verify-bill-added-text ${
                        isOLBOrIpadApp()
                          ? 'verify-bill-added-text-olb'
                          : 'verify-bill-added-text-tux'
                      }`}
                    >
                      {READY_TO_GO?.ALREADY_ADDED}
                    </p>
                  )
                }
                id="verified-billers"
                gapOnBottom={
                  isOLBOrIpadApp() && i === verifiedBills?.length - 1
                    ? '0'
                    : '8'
                }
                key={payeeId}
              >
                <div className="verify-bill-biller-details">
                  <img
                    name="logo"
                    src={getUSBExBillerLogo(merchantData?.billerLogoUrl)}
                    alt="confirmation logo"
                    aria-hidden
                    style={{ height: '2rem', width: '2rem' }}
                  />
                  <div
                    id={`added_biller_${i}`}
                    className="verify-bill-billname usb-tg-body-medium usb-c-gray-90"
                  >
                    {merchantData?.billerName}
                    <p
                      id="added_biller_maskedaccountNumber"
                      className="usb-tg-caption usb-c-gray-70"
                    >
                      {payeeAccountInfo &&
                        payeeAccountInfo[0]?.maskedaccountNumber}
                    </p>
                  </div>
                </div>
              </BlockLayout>
            )
          )}
        </>
      )}
    </div>
  )
}

VerifyBillsContainer.propTypes = {
  verifiedBills: PropTypes.arrayOf(PropTypes.any).isRequired,
  nonVerifiedBills: PropTypes.arrayOf(PropTypes.any).isRequired,
  errors: PropTypes.arrayOf(PropTypes.any).isRequired,
  handleOnChange: PropTypes.func.isRequired,
  count: PropTypes.number.isRequired,
  handleBillerRemoval: PropTypes.func.isRequired,
  inlineMsg: PropTypes.string,
  apierror: PropTypes.arrayOf(PropTypes.any),
  // updateCallback: PropTypes.func.isRequired,

  errorCount: PropTypes.bool.isRequired
}
VerifyBillsContainer.defaultProps = {
  inlineMsg: '',
  apierror: []
}

export default VerifyBillsContainer
